import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import {
  Button,
  Card,
  Container,
  Grid,
  LinearProgress
} from '@material-ui/core';
import Header from './Header';
import MyTextInput from './MyTextInput';

function ContactInfo({ formData, setFormData, calculateResults, goToResults }) {
  let [isSubmitting, setIsSubmitting] = useState(false);

  async function withoutEmailSubmit() {
    setIsSubmitting(true);

    await calculateResults(formData);
    goToResults();
  }

  return (
    <React.Fragment>
      <Header title="Get Your Personalized Recommendation And A Code For 20% Off Sent Right To Your Inbox" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              name: yup.string()
                .max(15, 'Maximum length of 15 characters')
                .required('Required'),
              email: yup.string()
                .email('Invalid email address')
                .required('Required')
            })}
            onSubmit={async (values, actions) => {
              console.log(JSON.parse(JSON.stringify(values)));

              actions.setSubmitting(true);

              setFormData(values);

              await calculateResults(values);
              goToResults();
            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MyTextInput name="name" type="text" label="First Name" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyTextInput name="email" type="email" label="Email" />
                    </Grid>
                    <Grid item xs={12}>
                      {formik.isSubmitting ? (
                        <LinearProgress />
                      ) : (
                        <Button variant="contained" color="primary" type="submit" fullWidth>Next</Button>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {isSubmitting ? (
                        <LinearProgress />
                      ) : (
                        <Button
                          fullWidth
                          onClick={withoutEmailSubmit}
                          variant="contained"
                        >
                          I don't want to save 20%
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre>
                  <pre>{JSON.stringify(formik.errors, null, 2)}</pre> */}
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default ContactInfo;